"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionsFields = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_panel_1 = require("../../composite/form/fields/form-panel");
const form_select_1 = require("../../composite/form/fields/form-select");
const form_editor_1 = require("../../composite/form/fields/form-editor");
const selector_1 = require("../../composite/form/selectors/selector");
const common_types_1 = require("../common-types");
const actions_api_1 = require("./actions-api");
function ActionsFields() {
    const intl = react_intl_1.useIntl();
    const scriptType = selector_1.useFormSelector((data) => data.scriptType);
    const types = actions_api_1.useScriptTypes();
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_ACTIONS_PANEL_TITLE", defaultMessage: "Skript" }) },
        react_1.default.createElement(form_select_1.FormSelect, { name: "scriptType", required: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_ACTIONS_FIELD_LABEL_SCRIPT_TYPE", defaultMessage: "Skriptovac\u00ED jazyk" }), helpLabel: intl.formatMessage({
                id: 'EAS_ACTIONS_FIELD_HELP_SCRIPT_TYPE',
                defaultMessage: ' ',
            }), source: types, tooltipMapper: (o) => o.name, valueIsId: true }),
        react_1.default.createElement(form_editor_1.FormEditor, { name: "script", required: true, disabled: scriptType == null, language: scriptType === common_types_1.ScriptType.GROOVY ? 'java' : 'javascript', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_ACTIONS_FIELD_LABEL_SCRIPT", defaultMessage: "Skript" }), helpLabel: intl.formatMessage({
                id: 'EAS_ACTIONS_FIELD_HELP_SCRIPT',
                defaultMessage: ' ',
            }) })));
}
exports.ActionsFields = ActionsFields;
//# sourceMappingURL=actions-fields.js.map